// extracted by mini-css-extract-plugin
export var checkbox = "_8l-0";
export var circle = "_8l-3";
export var horizontalContainer = "_8l-7";
export var sm = "_8l-5";
export var switch0 = "_8l-2";
export var switchDisabled = "_8l-8";
export var switchEnabled = "_8l-1";
export var textSwitchContainer = "_8l-9";
export var textSwitchOption = "_8l-a";
export var textSwitchOptionSelected = "_8l-b";
export var verticalContainer = "_8l-6";
export var xs = "_8l-4";